import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  original: attr('string'),
  images: attr(),
  videos: attr(),
  asset: belongsTo('asset', { async: false }),
});
